import { NewPeriod } from '@app/models/period';
import api from '@services/api';

import { PaginationResponse } from '../models/pagination';
import { SharingResultRequest } from '../models/sharing';
import { FileResponse } from '../models/sharingResult';

/**
 * <p>
 * API endpoints that cover all resource sharing result related CRUD calls
 */
export const SharingResultApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // POST
    CreateSharingResult: builder.mutation<PaginationResponse<NewPeriod>, SharingResultRequest>({
      query: (input: SharingResultRequest) => ({
        url: encodeURI(`/school/sharing-result/start?periodDate=${input.periodDate}`),
        method: 'POST',
      }),
      invalidatesTags: ['Periods'],
    }),
    generateSignedLink: builder.query<FileResponse, string | undefined>({
      query: (period) => ({
        url: encodeURI('/school/sharing-result/generateSignedLink'),
        method: 'POST',
        body: { period },
      }),
    }),
  }),
});

export const { useCreateSharingResultMutation, useGenerateSignedLinkQuery } = SharingResultApi;
